import React from "react";
import Popover from "@material-ui/core/Popover";
import TableSkeleton from "../Loader/TableSkeleton";
import "./ScanResultPopup.css";

export interface ScanResultPopupProps<T> {
  open: boolean;
  anchorEl: HTMLElement | null;
  headers: Array<{
    label: string;
    key: keyof T;
  }>;
  data: T[];
  loading?: boolean;
  skeletonRows?: number;
  skeletonColumns?: number;
  onClose?: () => void;
  onRowClick?: (row: T) => void; 
}

const ScanResultPopup = <T,>({
  open,
  anchorEl,
  headers,
  data,
  loading = false,
  skeletonRows = 4,
  skeletonColumns = 2,
  onClose,
  onRowClick
}: ScanResultPopupProps<T>) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      disableRestoreFocus
      classes={{ paper: "scan-popover-paper" }}

    >
      <div className="scan-popup">
        {/* Header */}
        <div className="scan-popup-header">
          {headers.map((h) => (
            <span key={String(h.key)}>{h.label}</span>
          ))}
        </div>

        {/* Body */}
        {loading ? (
          <TableSkeleton
            rows={skeletonRows}
            columns={skeletonColumns}
          />
        ) : (
          <div className="scan-popup-body">
            {data.length ? (
              data.map((row, rowIndex) => (
                <div className="scan-popup-row clickable" 
                  key={rowIndex}
                  onClick={() => {
                    onRowClick?.(row); 
                    onClose?.();       
                  }}
                >
                  {headers.map((h) => (
                    <span key={String(h.key)}>
                      {String(row[h.key] ?? "--")}
                    </span>
                  ))}
                </div>
              ))
            ) : (
              <div className="scan-popup-empty">No data found</div>
            )}
          </div>
        )}
      </div>
    </Popover>
  );
};

export default ScanResultPopup;
